var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitGameImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 255,
    viewBox: "0 0 283 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.6074,
    y: 67.3352,
    width: 61,
    height: 61,
    transform: "rotate(14.4993 15.6074 67.3352)",
    fill: "#F1C424"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 177.367,
    width: 133.832,
    height: 133.832,
    transform: "rotate(38.5286 177.367 0)",
    fill: "#F1C424"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.612 75.0425H162.073C149.074 75.0425 138.5 85.6167 138.5 98.6158C138.5 111.615 149.074 122.189 162.073 122.189H206.654C219.652 122.189 230.227 111.615 230.227 98.6158C230.227 85.6167 219.652 75.0425 206.654 75.0425H186.115V52V51.5H185.615H183.112H182.612V52V75.0425ZM206.654 118.685H162.073C151.008 118.685 142.003 109.681 142.003 98.6145C142.003 87.548 151.007 78.5441 162.073 78.5441H206.654C217.72 78.5441 226.725 87.548 226.725 98.6145C226.725 109.681 217.72 118.685 206.654 118.685Z",
    fill: "#8F7519",
    stroke: "#8F7519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.605 100.988C216.16 100.988 217.42 99.7277 217.42 98.1727C217.42 96.6177 216.16 95.3571 214.605 95.3571C213.05 95.3571 211.789 96.6177 211.789 98.1727C211.789 99.7277 213.05 100.988 214.605 100.988Z",
    fill: "#8F7519"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.892 100.988C202.447 100.988 203.707 99.7277 203.707 98.1727C203.707 96.6177 202.447 95.3571 200.892 95.3571C199.337 95.3571 198.076 96.6177 198.076 98.1727C198.076 99.7277 199.337 100.988 200.892 100.988Z",
    fill: "#8F7519"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207.527 94.351C209.082 94.351 210.342 93.0904 210.342 91.5354C210.342 89.9803 209.082 88.7197 207.527 88.7197C205.972 88.7197 204.711 89.9803 204.711 91.5354C204.711 93.0904 205.972 94.351 207.527 94.351Z",
    fill: "#8F7519"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.527 108.066C209.082 108.066 210.342 106.806 210.342 105.251C210.342 103.696 209.082 102.435 207.527 102.435C205.972 102.435 204.711 103.696 204.711 105.251C204.711 106.806 205.972 108.066 207.527 108.066Z",
    fill: "#8F7519"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.143 95.5774H163.795V91.2288C163.795 89.8435 162.535 88.7185 160.979 88.7185C159.424 88.7185 158.164 89.8423 158.164 91.2288V95.5774H153.815C152.43 95.5774 151.305 96.8388 151.305 98.393C151.305 99.9485 152.428 101.209 153.815 101.209H158.164V105.557C158.164 106.943 159.424 108.068 160.979 108.068C162.535 108.068 163.795 106.944 163.795 105.557V101.209H168.143C169.529 101.209 170.654 99.9485 170.654 98.393C170.653 96.8388 169.529 95.5774 168.143 95.5774Z",
    fill: "#8F7519"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M181.801 107.374H177.813C177.078 107.374 176.482 107.97 176.482 108.705C176.482 109.439 177.078 110.035 177.813 110.035H181.801C182.535 110.035 183.131 109.439 183.131 108.705C183.131 107.97 182.535 107.374 181.801 107.374Z",
    fill: "#8F7519"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.165 107.374H188.176C187.443 107.374 186.846 107.97 186.846 108.705C186.846 109.439 187.443 110.035 188.176 110.035H192.165C192.9 110.035 193.496 109.439 193.496 108.705C193.496 107.97 192.9 107.374 192.165 107.374Z",
    fill: "#8F7519"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 245.861,
    y: 218,
    width: 28.2244,
    height: 28.2244,
    transform: "rotate(20.4487 245.861 218)",
    fill: "#F1C424"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitGameImg);
export default __webpack_public_path__ + "static/media/benefit-game-img.c25b4399b777ef22c5d3ebeddd3c51b0.svg";
export { ForwardRef as ReactComponent };